module.exports = __webpack_public_path__ + "static/media/class_job_013.df7c281c.svg";